



























































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { debounce } from 'lodash';

import InfoIcon from '@/components/icons/InfoV2.vue';
import Coins from '@/components/icons/Coins.vue';
import Typography from '@/componentsV2/atoms/Typography/Typography.vue';
import Amount from '@/componentsV2/molecules/Amount/Amount.vue';
import { SmartBusinessSignupData } from '@/models/smart-business-signup';

import segmentIo from '@/utils/segment.io';

import SectionHeader from './SectionHeader.vue';
import { DEFAULT_BRANDED_COIN_IMAGE } from '../Constants';

const ON_CHANGE_KEY = 'giftPercentageRecommendation';
const COINS = 100;

@Component({
  components: {
    Typography,
    Amount,
    SectionHeader,
    InfoIcon,
    Coins
  }
})
export default class GiftCards extends Vue {
  @Prop() readonly businessName!: string;
  @Prop() readonly brandedCoinUrl!: string;
  @Prop() readonly brandedCoinColor!: string;
  @Prop() readonly defaultSelectedValue!: number | null;
  @Prop() readonly defaultValues!: [number, string][];
  @Prop() readonly loyalty!: number | null;

  customValue: number | null = this.customValueData;
  selectedIndex: number | null =
    this.defaultSelectedValue &&
    this.defaultValues.findIndex(val => val[0] === this.defaultSelectedValue);
  formData = this.smartBusinessSignupData.giftPercentageRecommendation;

  isValidValue = true;

  get showBrandedCoinPlaceholder(): boolean {
    return this.brandedCoinUrl === DEFAULT_BRANDED_COIN_IMAGE;
  }

  get smartBusinessSignupData(): SmartBusinessSignupData {
    return this.$store.getters['businessOnboarding/getSmartBusinessSignup'];
  }

  get customValueData() {
    if (
      !this.defaultValues
        .map(item => item[0])
        .includes(
          this.smartBusinessSignupData.giftPercentageRecommendation.percentage
        )
    ) {
      return this.smartBusinessSignupData.giftPercentageRecommendation
        .percentage;
    }
    return null;
  }

  get invalidInput() {
    return !this.isValidValue && this.formData.enabled;
  }

  get giftPercentageLabel() {
    return `${COINS} Coins`;
  }

  get coinBonusValue() {
    return this.formData.percentage || 0;
  }

  @Watch('formData', { deep: true })
  onChangeEmit() {
    this.$emit('onChange', this.formData, ON_CHANGE_KEY);
  }

  @Watch('loyalty')
  onLoyaltyChange() {
    this.validate(this.formData.percentage || 0);
  }

  validate(percentage: number) {
    this.isValidValue = this.loyalty === null || percentage >= this.loyalty;
  }

  changeEnable(value: boolean) {
    this.formData.enabled = value;
    this.onLoyaltyChange();
    segmentIo.track('AI Sign Up | Gift Activation Toggle', {
      Enabled: value
    });
  }

  handleInput(value: number) {
    this.customValue = value;
    this.formData.percentage = value;
    this.selectedIndex = null;
    debounce(() => {
      segmentIo.track('AI Sign Up | Custom Gift Rate Selected', {
        Percentage: value
      });
    }, 1000);
  }

  inputFocus(focus: boolean) {
    this.isValidValue = true;
    if (focus) return;
    this.validate(this.formData.percentage || 0);
  }

  handleClick(value: number, type: string, index: number) {
    this.isValidValue = true;

    if (type === 'custom') {
      this.selectedIndex = null;
      return;
    }
    this.customValue = null;
    this.selectedIndex = index;
    this.formData.percentage = value;
    this.validate(value);

    segmentIo.track('AI Sign Up | Gift Rate Selected', {
      Percentage: value
    });
  }
}
